import { render, staticRenderFns } from "./IShardList.vue?vue&type=template&id=0c7d24d6&"
import script from "./IShardList.vue?vue&type=script&lang=ts&"
export * from "./IShardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports